// extracted by mini-css-extract-plugin
module.exports = {"page":"PowerKits48vSystem_page__sCqYe"};